import palette from './palette';

const font = "'Roboto', 'Prompt', sans-serif";

export default {
  fontFamily: font,
  fontWeight: 400,
  h1: {
    fontWeight: 500,
    fontSize: '28px',
    color: '#222222',
  },
  h2: {
    fontWeight: 500,
    fontSize: '24px',
  },
  h3: {
    fontWeight: 500,
    fontSize: '22px',
  },
  h4: {
    fontWeight: 500,
    fontSize: '20px',
  },
  h5: {
    fontWeight: 500,
    fontSize: '18px',
  },
  h6: {
    fontWeight: 500,
    fontSize: '16px',
  },
  body: {
    fontSize: '16px',
  },
  button: {
    fontSize: '14px',
    fontWeight: '500',
  },
  a: {
    color: palette.text.primary,
  },
  body1: {
    fontSize: '14px',
    fontWeight: '400',
  },
  body2: {
    fontSize: '14px',
    fontWeight: '400',
  },
};
